
import { generateEmailTemplate, generateCallScript } from '@/services/communication';
import { saveTemplate } from '@/services/communication/templates';
import { Lead } from '@/types/lead';
import { Profile } from '@/lib/types';
import { getCompanyById } from '@/services/companyService';

export const generateInitialTemplates = async (
  lead: Lead,
  profile: Profile | null
): Promise<void> => {
  if (!profile) {
    console.warn('No profile info available for template generation');
    return;
  }

  let companyName = '';
  if (profile.company_id) {
    try {
      const company = await getCompanyById(profile.company_id);
      companyName = company?.name || '';
    } catch (error) {
      console.error('Error fetching company name:', error);
    }
  }

  const senderInfo = {
    senderName: `${profile.first_name || ''} ${profile.last_name || ''}`.trim(),
    senderRole: profile.job_title || 'Sales Representative',
    senderCompany: companyName
  };

  try {
    // Generate and save email template
    const emailTemplate = await generateEmailTemplate(lead.id, senderInfo);
    if (emailTemplate) {
      await saveTemplate({
        name: `Initial Email for ${lead.name}`,
        content: emailTemplate,
        type: 'email',
        leadStatus: 'new',
        category: 'initial_contact',
        leadId: lead.id,           // Add lead ID
        companyId: lead.companyId  // Add company ID
      });
    }

    // Generate and save call script
    const callScript = await generateCallScript(lead.id, senderInfo);
    if (callScript) {
      await saveTemplate({
        name: `Initial Call Script for ${lead.name}`,
        content: callScript,
        type: 'call',
        leadStatus: 'new',
        category: 'initial_contact',
        leadId: lead.id,           // Add lead ID
        companyId: lead.companyId  // Add company ID
      });
    }
  } catch (error) {
    console.error('Error generating initial templates:', error);
    console.error('Lead details:', { 
      leadId: lead.id, 
      leadName: lead.name, 
      companyId: lead.companyId 
    });
    throw error;
  }
};
